<!--
  ~ Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
  -->
@if (!loadError()) {
  <img [src]="userId | avatarUrl" alt="" class="avatar-size-{{ size }}" (load)="onImageLoad()" (error)="onImageError()">
} @else {
  <mat-icon class="avatar-size-{{ size }} avatar-fallback">account_circle</mat-icon>
}
